import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Card, Grid, Accordion, Dropdown, Button, Icon} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';

const {getAccessoriesCombos, getCombosCandidateTasks, getComboTasks, selectCombo} = Actions;

function parseCombos(combos) {
  const options = Object.keys(combos);
  return options.map((combo) => ({'text': combo, 'value': combo}));
}

const SearchButton = ({searchStatus, handleSearchClick}) => {
  return (
    <Button primary onClick={handleSearchClick} disabled={searchStatus}>
      BUSCAR
    </Button>
  );
};

const ComboSelector = ({combos, handleComboChange, selectorStatus}) => {
  return (
    <Dropdown
      search
      selection
      name='combo'
      options={parseCombos(combos)}
      disabled={selectorStatus}
      onChange={handleComboChange}
    />
  );
};

const ComboInfo = ({selectedCombo}) => {
  const [activeIndex, setActiveIndex] = useState(0);

  function handleClick(e, titleProps) {
    const {index} = titleProps;
    const newIndex = activeIndex === index ? -1 : index;
    setActiveIndex(newIndex);
  }

  if (!selectedCombo) {
    return null;
  }

  return (
    <Accordion fluid styled>
      <Accordion.Title
        index={1}
        active={activeIndex === 1}
        onClick={handleClick}
      >
        <Icon name='dropdown' />
        <span>{selectedCombo.description}</span>
      </Accordion.Title>
      <Accordion.Content active={activeIndex === 1}>
        {selectedCombo.models.map((item, index) => (
          <div key={index} className='combo-info'>
            <span>
              <strong>Katashiki:</strong>
            </span>
            <span>{item.masterCode}</span>
            <span>
              <strong>Modelo:</strong>
            </span>
            <span>{item.model}</span>
          </div>
        ))}
      </Accordion.Content>
    </Accordion>
  );
};

const Header = () => {
  const comboTasks = useSelector((state) => state.comboTasks);
  const dispatch = useDispatch();
  const {combos, submitting, loadingCombos, loadingCandidateTasks,
    loadingTasks, selectedCombo} = comboTasks;

  const searchStatus = !selectedCombo || loadingTasks || loadingCandidateTasks;
  const selectorStatus =
    submitting || loadingCombos || loadingCandidateTasks || loadingTasks;

  useEffect(() => {
    dispatch(getAccessoriesCombos());
  }, [dispatch]);

  function handleComboChange(e, {value}) {
    dispatch(selectCombo(value));
  }

  function handleSearchClick() {
    dispatch(getCombosCandidateTasks(selectedCombo.code));
    dispatch(getComboTasks(selectedCombo.code));
  }

  return (
    <Card raised fluid className='combo-tasks-header'>
      <Grid>
        <Grid.Row>
          <Grid.Column>
            <h2>Relación Tarea - Combo</h2>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column className='title-bar-actions' width={16}>
            <label htmlFor='combo'>
              <strong>Combo</strong>
            </label>
            <ComboSelector
              combos={combos}
              selectorStatus={selectorStatus}
              handleComboChange={handleComboChange}
            />
            <SearchButton
              searchStatus={searchStatus}
              handleSearchClick={handleSearchClick}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16}>
            <ComboInfo selectedCombo={selectedCombo} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card>
  );
};

export default Header;
